const refundTypeInfractionAPI = require('../infraction/refundType');

const refundType = {
  operationalFlaw: 0,
  fraud: 1,
  refundCanceled: 2,
  convertToJDPI(type) {
    switch (type) {
      case refundTypeInfractionAPI.OPERATIONAL_FLAW:
        return this.operationalFlaw;
      case refundTypeInfractionAPI.FRAUD:
        return this.fraud;
      case refundTypeInfractionAPI.REFUND_CANCELLED:
        return this.refundCanceled;
      default:
        throw new Error('Invalid refund type to convert to JDPI');
    }
  },
  convertFromJDPI(type) {
    switch (type) {
      case this.operationalFlaw:
        return refundTypeInfractionAPI.OPERATIONAL_FLAW;
      case this.fraud:
        return refundTypeInfractionAPI.FRAUD;
      case this.refundCanceled:
        return refundTypeInfractionAPI.REFUND_CANCELLED;
      default:
        throw new Error('Invalid refund type to convert from JDPI');
    }
  }
};

module.exports = refundType;
